import { InjectionToken } from '@angular/core';


export interface IEmbedStartup {
	$promise: Promise<any>;
}

export const EMBED_STARTUP_INJECTION_TOKEN: InjectionToken<IEmbedStartup> = new InjectionToken('EmbedStartup');
